import { QuoteDocumentTypeRequest } from '@monetize/types/app';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { MdClear } from 'react-icons/md';
import {
  MBox,
  MButton,
  MCustomIconButton,
  MFlex,
  MFormField,
  MInput,
  MTooltip,
} from '../../../../../components/Monetize';

interface QuoteDocumentTypeFormProps {
  control: Control<QuoteDocumentTypeRequest>;
  errors: FieldErrors<QuoteDocumentTypeRequest>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  onCancel: () => void;
  isLoading: boolean;
  isDirty: boolean;
  submitLabel?: string;
  showCancel?: boolean;
}

export const QuoteDocumentTypeForm = ({
  control,
  errors,
  onSubmit,
  onCancel,
  isLoading,
  isDirty,
  submitLabel = 'Save',
  showCancel = true,
}: QuoteDocumentTypeFormProps) => {
  return (
    <form onSubmit={onSubmit}>
      <MFlex alignItems="flex-end" gap={4} mb={4}>
        <MBox w="250px">
          <MFormField error={errors.label} label="Document Type" isRequired>
            <Controller
              name="label"
              control={control}
              render={({ field }) => (
                <MInput maxLength={100} {...field} isDisabled={isLoading} />
              )}
            />
          </MFormField>
        </MBox>

        <MButton
          // w="77px"
          size="sm"
          type="submit"
          variant="primary"
          isDisabled={!isDirty || isLoading}
          isLoading={isLoading}
        >
          {submitLabel}
        </MButton>

        {showCancel && (
          <MTooltip label="Close">
            <MBox>
              <MCustomIconButton
                variant="icon"
                btnSize={3.5}
                padding={0}
                containerSize={7}
                icon={MdClear}
                aria-label="Close"
                onClick={onCancel}
              />
            </MBox>
          </MTooltip>
        )}
      </MFlex>
    </form>
  );
};
